import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import { PlusCircleOutlined } from "@ant-design/icons";
import {
  _LIST_STAFFS,
  _LIST_TASK_CATEGORIES,
  _LIST_TASK_LOG,
  _LIST_TASK_PRIORITIES,
  _LIST_TASKS,
} from "../../models/task";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { momentDate, MuiModalWindow } from "../../utils";
import AddTask from "./addTask";
import moment from "moment";

const ActivityLog = (props) => {
  const context = useContext(PsContext);

  useEffect(() => {
    console.log(props.dataSource);
  }, [props.dataSource]);

  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "#4caf50"; // Green for completed
      case "processing":
        return "#2196f3"; // Blue for processing
      case "overdue":
        return "#f44336"; // Red for overdue
      case "not_yet_started":
        return "#ff9800"; // Orange for not yet started
      default:
        return "#9e9e9e"; // Gray for undefined statuses
    }
  };

  // Sample state for managing selections

  const renderLog = (log) => {
    return (
      <Box key={log.id} mb={2} p={2} border="1px solid #ccc" borderRadius="8px">
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              {moment(log.update_date).format("DD-MM-YYYY")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="caption"
              style={{
                color: "white",
                backgroundColor: getStatusColor(log.status_update),
                padding: "4px 8px",
                borderRadius: "4px",
                display: "inline-block", // Allows the background color to fill the text area
                width: "100%", // Make the status fill the full width below the border line
              }}
            >
              {log.status_update.replace(/_/g, " ")}
            </Typography>
          </Grid>
        </Grid>
        <Typography variant="body1" mt={1}>
          {log.comment}
        </Typography>

        <Typography variant="caption" color="textSecondary">
          {log.employee_name}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Card>
        <CardContent>
          {props.dataSource.map((log) => renderLog(log))}
        </CardContent>
      </Card>
    </>
  );
};

export default ActivityLog;
